import {
  Box,
  Center,
  Flex,
  Heading,
  Image,
  useColorMode,
} from '@chakra-ui/react';

import Footer from 'views/signin/components/Footer';

import BigLogo from 'assets/img/others/big_precision_x.png';
import PolicyPilotLogo from 'assets/img/others/policy_pilot.png';
import MyChoiceDarkLogo from 'assets/img/others/mychoice_dark_mode.webp';

import {
  ORGANISATION_THE_BIG_DEV,
  ORGANISATION_THE_BIG_PR,
  ORGANISATION_THE_BIG,
} from 'config';

const Background = ({
  children,
  organization,
}: {
  children: JSX.Element;
  organization: string;
}) => {
  const { colorMode } = useColorMode();

  const getLogo = () => {
    if (!organization) return null;

    if (
      [
        ORGANISATION_THE_BIG_DEV,
        ORGANISATION_THE_BIG_PR,
        ORGANISATION_THE_BIG,
      ].includes(organization)
    ) {
      // Use dark mode logo if available, otherwise use default
      return colorMode === 'dark' ? MyChoiceDarkLogo : BigLogo;
    }

    // Use dark mode logo if available, otherwise use default
    return colorMode === 'dark' ? MyChoiceDarkLogo : PolicyPilotLogo;
  };

  return (
    <Flex position="relative" h="max-content">
      <Flex
        h={{
          sm: 'initial',
          md: 'unset',
          lg: '100vh',
          xl: '97vh',
        }}
        w="100%"
        maxW={{ md: '66%', lg: '1313px' }}
        mx="auto"
        pt={{ sm: '50px', md: '0px' }}
        px={{ lg: '30px', xl: '0px' }}
        ps={{ xl: '70px' }}
        justifyContent="start"
        direction="column"
      >
        {children}
        <Box
          display={{ base: 'none', lg: 'block' }}
          h="100%"
          minH="100vh"
          w={{ lg: '50vw', '2xl': '44vw' }}
          position="absolute"
          right="0px"
          bgGradient="linear(to-b, brand.50, brand.400)"
          borderBottomLeftRadius={{ lg: '120px', xl: '200px' }}
          textAlign="center"
        >
          <Center h="100%">
            <Box>
              <Heading
                fontSize={42}
                color="#fff"
                whiteSpace="pre-line"
                textAlign="center"
              >
                Welcome to
              </Heading>
              <Image mt="40px" mb="30%" src={getLogo()}></Image>
            </Box>
          </Center>
        </Box>
        <Footer />
      </Flex>
    </Flex>
  );
};

export default Background;
